const meridians = ['', 'W4', 'W5', 'W6'];

const accreditedMunicipalities = [
  { contains: 'calgary', municipality: 'Calgary', phone: '(403) 268-2489', website: 'www.calgary.ca' },
  { contains: 'edmonton', municipality: 'Edmonton', phone: '(780) 496-3628', website: 'www.edmonton.ca/programs_services/fire_rescue/fuel-tank-permits' },
  { contains: 'lethbridge', municipality: 'Lethbridge', phone: '(403) 320-3830', website: 'www.lethbridge.ca' },
  { contains: 'medicine hat', municipality: 'Medicine Hat', phone: '(403) 529-8374', website: 'www.medicinehat.ca' },
  { contains: 'red deer', municipality: 'Red Deer', phone: '(403) 342-8111', website: 'www.reddeer.ca' },
  { contains: 'gasoline alley', municipality: 'Red Deer', phone: '(403) 342-8111', website: 'www.reddeer.ca' },
  { contains: 'spruce grove', municipality: 'Spruce Grove', phone: '(780) 962-2611', website: 'www.sprucegrove.org' },
  { contains: 'newell', municipality: 'County of Newell', phone: '(403) 362-3266', website: 'www.countyofnewell.ab.ca' },
  { contains: 'newell#4', municipality: 'County of Newell', phone: '(403) 362-3266', website: 'www.countyofnewell.ab.ca' },
  { contains: 'bassano', municipality: 'County of Newell', phone: '(403) 362-3266', website: 'www.countyofnewell.ab.ca' },
  { contains: 'duchess', municipality: 'County of Newell', phone: '(403) 362-3266', website: 'www.countyofnewell.ab.ca' },
  { contains: 'rosemary', municipality: 'County of Newell', phone: '(403) 362-3266', website: 'www.countyofnewell.ab.ca' },
  { contains: 'leduc county', municipality: 'Leduc County', phone: '(780) 955-3555', website: 'www.leduc-county.com' },
  { contains: 'nisku', municipality: 'Leduc County', phone: '(780) 955-3555', website: 'www.leduc-county.com' },
  { contains: 'wood buffalo', municipality: 'Wood Buffalo', phone: '(780) 743-7000', website: 'www.rmwb.ca' },
  { contains: 'fort mcmurray', municipality: 'Wood Buffalo', phone: '(780) 743-7000', website: 'www.rmwb.ca' },
  { contains: 'fort mackay', municipality: 'Wood Buffalo', phone: '(780) 743-7000', website: 'www.rmwb.ca' },
  { contains: 'fort chipewyan', municipality: 'Wood Buffalo', phone: '(780) 743-7000', website: 'www.rmwb.ca' },
  { contains: 'conklin', municipality: 'Wood Buffalo', phone: '(780) 743-7000', website: 'www.rmwb.ca' },
  { contains: 'anzac', municipality: 'Wood Buffalo', phone: '(780) 743-7000', website: 'www.rmwb.ca' },
  { contains: 'taber', municipality: 'Taber', phone: '(403) 223-6010', website: 'www.taber.ca' },
];

function findAccreditedMunicipality(city) {
  const normalized = (city || '').trim().toLowerCase();
  if (!normalized) return null;
  return accreditedMunicipalities.find((m) => normalized.includes(m.contains)) || null;
}

export {
  meridians,
  accreditedMunicipalities,
  findAccreditedMunicipality,
};
